import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "content-panel",
  style: {"max-width":"1000px"}
}
const _hoisted_2 = { class: "panel-header" }
const _hoisted_3 = { class: "panel-icon celebration" }
const _hoisted_4 = { class: "panel-body" }
const _hoisted_5 = { class: "celebration-box" }
const _hoisted_6 = { class: "features-grid" }
const _hoisted_7 = {
  key: 0,
  class: "request-badge"
}
const _hoisted_8 = { class: "status-card-text" }
const _hoisted_9 = { class: "status-card-actions" }
const _hoisted_10 = ["disabled", "title"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "confirm-dialog-header" }
const _hoisted_14 = { class: "confirm-dialog-footer" }
const _hoisted_15 = { class: "confirm-dialog-header warning" }
const _hoisted_16 = { class: "confirm-dialog-footer" }
const _hoisted_17 = { class: "job-summary-header" }
const _hoisted_18 = { class: "header-left" }
const _hoisted_19 = { class: "header-subtitle" }
const _hoisted_20 = { class: "job-summary-body" }
const _hoisted_21 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_22 = {
  key: 1,
  class: "table-wrapper"
}
const _hoisted_23 = { class: "job-summary-table" }
const _hoisted_24 = { class: "col-job" }
const _hoisted_25 = { class: "col-num" }
const _hoisted_26 = { class: "col-money" }
const _hoisted_27 = { class: "col-money" }
const _hoisted_28 = { class: "col-money" }
const _hoisted_29 = { class: "col-money total-highlight" }
const _hoisted_30 = { class: "total-row" }
const _hoisted_31 = { class: "col-num" }
const _hoisted_32 = { class: "col-money" }
const _hoisted_33 = { class: "col-money" }
const _hoisted_34 = { class: "col-money" }
const _hoisted_35 = { class: "col-money total-highlight" }
const _hoisted_36 = { class: "insurance-detail-section" }
const _hoisted_37 = {
  key: 0,
  class: "detail-table-wrapper"
}
const _hoisted_38 = { class: "job-summary-table detail-table" }
const _hoisted_39 = { class: "col-job" }
const _hoisted_40 = { class: "col-money-sm" }
const _hoisted_41 = { class: "col-money-sm" }
const _hoisted_42 = { class: "col-money-sm" }
const _hoisted_43 = { class: "col-money-sm" }
const _hoisted_44 = { class: "col-money-sm" }
const _hoisted_45 = { class: "col-money-sm" }
const _hoisted_46 = { class: "col-money-sm total-highlight" }
const _hoisted_47 = { class: "total-row" }
const _hoisted_48 = { class: "col-money-sm" }
const _hoisted_49 = { class: "col-money-sm" }
const _hoisted_50 = { class: "col-money-sm" }
const _hoisted_51 = { class: "col-money-sm" }
const _hoisted_52 = { class: "col-money-sm" }
const _hoisted_53 = { class: "col-money-sm" }
const _hoisted_54 = { class: "col-money-sm total-highlight" }
const _hoisted_55 = { class: "job-summary-footer" }

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import WageReportExcel from '@/components/wage/WageReportExcel.vue';
import WageSlipPdf from '@/components/wage/WageSlipPdf.vue';
import WageTaxReq from '@/components/wage/tax/WageTaxReq.vue';
import { useRouter } from 'vue-router';

interface InsuranceDetail {
  nationalPension: number;
  healthInsurance: number;
  longTermCare: number;
  employmentInsurance: number;
  unemployment: number;
  industrialAccident: number;
}

interface JobSummaryRow {
  job: string;
  count: number;
  totalPay: number;
  socialInsurance: number;
  retirement: number;
  detail: InsuranceDetail;
}

// 간접비 종사자구분 (테이블에서 제외)

export default /*@__PURE__*/_defineComponent({
  __name: 'StepFinal',
  props: {
    stepCompleted: { type: Boolean },
    isConfirmed: { type: Boolean },
    isConfirming: { type: Boolean },
    yearMonth: {},
    paymentDate: {},
    sanRate: {}
  },
  emits: ["view-result", "confirm", "release", "require-payment-date"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();
const router = useRouter();

const isConfirmed = computed(() => !!props.isConfirmed);
const isConfirming = computed(() => !!props.isConfirming);
const stepCompleted = computed(() => props.stepCompleted ?? false);
const yearMonth = computed(() => props.yearMonth || store.state.lebYm || '');

// 확정/해제 확인 다이얼로그 상태
const showConfirmDialog = ref(false);
const showReleaseDialog = ref(false);

// 임금신고 요청 관련
const showTaxReqDialog = ref(false);
const taxRequestData = ref<any>(null);

const hasActiveRequest = computed(() => {
  return taxRequestData.value && taxRequestData.value.wtr_status === '요청';
});

// 확정 해제 가능 여부 (요청하지 않았거나 취소한 경우에만 가능)
const canReleaseConfirmation = computed(() => {
  // 요청 데이터가 없거나 취소 상태면 해제 가능
  if (!taxRequestData.value) return true;
  if (taxRequestData.value.wtr_status === '취소') return true;
  return false;
});

const taxRequestStatusText = computed(() => {
  if (!taxRequestData.value) return '관리자에게 신고 요청';
  switch (taxRequestData.value.wtr_status) {
    case '요청': return '요청 대기중';
    case '승인': return '승인 완료';
    case '반려': return '반려됨';
    case '취소': return '관리자에게 신고 요청';
    default: return '관리자에게 신고 요청';
  }
});

// 인건비 지출비율 참고 모달
const showJobSummaryDialog = ref(false);
const showInsuranceDetail = ref(false);

// 엑셀 다운로드 관련
const wageReportExcelRef = ref<any>(null);
// 급여명세서 PDF 관련
const wageSlipPdfRef = ref<any>(null);
const isLoadingData = ref(false);
const groupedMemberData = ref<any[]>([]);
const taxData = ref<any>(null);
const settingsData = ref<any>({});
const payrollDetails = ref<Record<number, any>>({});      // 급여 상세 (StepThree의 calculatePayrollDetails 결과)
const workTimeInfo = ref<Record<number, any>>({});        // 근무시간 정보
const sabokStaffData = ref<any[]>([]);
const sabokStaffSettings = ref<any>({});
const workInfoData = ref<any[]>([]);  // hh_emp_sabok_work_info 테이블 데이터 (엑셀용)

const hasDownloadableData = computed(() => {
  return workInfoData.value.length > 0;
});

const canDownload = computed(() => {
  return hasDownloadableData.value && !isLoadingData.value;
});

const handleGoDashboard = () => {
  router.push('/pgm/dashboard');
};

// 임금신고 요청 모달 열기
const handleOpenTaxReq = () => {
  showTaxReqDialog.value = true;
};

// 임금신고 요청 완료 시
const handleTaxReqSubmitted = () => {
  loadTaxRequestStatus();
};

// 임금신고 요청 취소 시
const handleTaxReqCancelled = () => {
  loadTaxRequestStatus();
};

// 임금신고 요청 상태 조회
const loadTaxRequestStatus = async () => {
  const user = store.state.user;
  if (!user?.m_sisul_code || !yearMonth.value) return;

  try {
    const response = await axios.get('/api/wage-process/tax-request', {
      params: {
        sisulCode: user.m_sisul_code,
        yearMonth: yearMonth.value
      }
    });

    if (response.data.success) {
      taxRequestData.value = response.data.data;
    }
  } catch (error) {
    console.error('임금신고 요청 상태 조회 오류:', error);
  }
};

// 급여명세서 열기 (모든 직원 임금명세서 한번에 보기)
const handleOpenWageSlip = async () => {
  if (isLoadingData.value) return;
  
  // 임금지급일 확인
  if (!props.paymentDate) {
    store.commit('showSnackbar', {
      text: '임금지급일을 먼저 설정해주세요.',
      color: 'warning'
    });
    emit('require-payment-date');
    return;
  }
  
  if (!hasDownloadableData.value) {
    await loadDownloadData();
  }

  if (!hasDownloadableData.value) {
    store.commit('showSnackbar', {
      text: '급여 데이터가 없습니다. 먼저 급여 데이터를 확인해주세요.',
      color: 'warning'
    });
    return;
  }

  if (wageSlipPdfRef.value) {
    wageSlipPdfRef.value.previewAllWageSlips();
  }
};

// 금액 포맷
const formatMoney = (value: number) => {
  if (!value && value !== 0) return '0';
  return new Intl.NumberFormat('ko-KR').format(Math.round(value));
};

// 년월 포맷
const formattedYearMonth = computed(() => {
  const ym = yearMonth.value;
  if (!ym || ym.length < 6) return '';
  return `${ym.substring(0, 4)}년 ${ym.substring(4, 6)}월`;
});

// 종사자구분별 색상
const getJobColor = (job: string) => {
  const colors: Record<string, string> = {
    '요양보호사': '#3b82f6',
    '사회복지사': '#8b5cf6',
    '센터장': '#f59e0b',
    '간호사': '#10b981',
    '간호조무사': '#06b6d4',
    '물리치료사': '#ec4899',
    '작업치료사': '#f43f5e',
  };
  return colors[job] || '#6b7280';
};

const indirectCostJobs = ['센터장'];

// 종사자구분별 요약 데이터
const jobSummaryData = computed<JobSummaryRow[]>(() => {
  if (!workInfoData.value || workInfoData.value.length === 0) return [];

  const jobMap = new Map<string, JobSummaryRow>();

  workInfoData.value.forEach((row: any) => {
    const job = row.emp_job || '기타';
    // 간접비 해당 종사자 제외
    if (indirectCostJobs.includes(job)) return;
    if (!jobMap.has(job)) {
      jobMap.set(job, {
        job,
        count: 0,
        totalPay: 0,
        socialInsurance: 0,
        retirement: 0,
        detail: {
          nationalPension: 0,
          healthInsurance: 0,
          longTermCare: 0,
          employmentInsurance: 0,
          unemployment: 0,
          industrialAccident: 0
        }
      });
    }

    const entry = jobMap.get(job)!;
    entry.count++;
    entry.totalPay += (row.ewi_total_pay || 0);

    // 사회보험 기관부담금 상세
    const centerYeon = row.ewi_center_yeon || 0;
    const centerGun = row.ewi_center_gun || 0;
    const centerJang = row.ewi_center_jang || 0;
    const centerGo = row.ewi_center_go || 0;
    const centerSil = row.ewi_center_sil || 0;
    const centerSan = row.ewi_center_san || 0;

    entry.detail.nationalPension += centerYeon;
    entry.detail.healthInsurance += centerGun;
    entry.detail.longTermCare += centerJang;
    entry.detail.employmentInsurance += centerGo;
    entry.detail.unemployment += centerSil;
    entry.detail.industrialAccident += centerSan;

    entry.socialInsurance += (centerYeon + centerGun + centerJang + centerGo + centerSil + centerSan);
    entry.retirement += (row.ewi_center_out || 0);
  });

  // 정렬: 요양보호사 > 사회복지사 > 센터장 > 기타
  const jobOrder = ['요양보호사', '사회복지사', '센터장', '간호사', '간호조무사', '물리치료사', '작업치료사'];
  return Array.from(jobMap.values()).sort((a, b) => {
    const aIdx = jobOrder.indexOf(a.job);
    const bIdx = jobOrder.indexOf(b.job);
    const aOrder = aIdx === -1 ? 999 : aIdx;
    const bOrder = bIdx === -1 ? 999 : bIdx;
    return aOrder - bOrder;
  });
});

// 합계
const jobSummaryTotals = computed(() => {
  const totals = {
    count: 0,
    totalPay: 0,
    socialInsurance: 0,
    retirement: 0,
    detail: {
      nationalPension: 0,
      healthInsurance: 0,
      longTermCare: 0,
      employmentInsurance: 0,
      unemployment: 0,
      industrialAccident: 0
    }
  };

  jobSummaryData.value.forEach(row => {
    totals.count += row.count;
    totals.totalPay += row.totalPay;
    totals.socialInsurance += row.socialInsurance;
    totals.retirement += row.retirement;
    totals.detail.nationalPension += row.detail.nationalPension;
    totals.detail.healthInsurance += row.detail.healthInsurance;
    totals.detail.longTermCare += row.detail.longTermCare;
    totals.detail.employmentInsurance += row.detail.employmentInsurance;
    totals.detail.unemployment += row.detail.unemployment;
    totals.detail.industrialAccident += row.detail.industrialAccident;
  });

  return totals;
});

// 인건비 지출비율 참고 모달 열기
const handleOpenJobSummary = async () => {
  if (isLoadingData.value) return;

  if (!hasDownloadableData.value) {
    await loadDownloadData();
  }

  if (!hasDownloadableData.value) {
    store.commit('showSnackbar', {
      text: '급여 데이터가 없습니다. 먼저 급여 데이터를 확인해주세요.',
      color: 'warning'
    });
    return;
  }

  showJobSummaryDialog.value = true;
};

// 원단위 절삭 함수 (예: 51131 -> 51130)
const truncateToTen = (value: number) => Math.floor(value / 10) * 10;

// 만 나이 계산 함수
const calculateAge = (birthDateStr: string, baseYm: string) => {
  if (!birthDateStr || !baseYm) return 0;
  const birthDate = new Date(birthDateStr);
  const baseYear = parseInt(baseYm.substring(0, 4));
  const baseMonth = parseInt(baseYm.substring(4, 6));
  const baseDate = new Date(baseYear, baseMonth, 0);
  let age = baseDate.getFullYear() - birthDate.getFullYear();
  if (baseDate.getMonth() < birthDate.getMonth() ||
    (baseDate.getMonth() === birthDate.getMonth() && baseDate.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

const formatToYMD = (value?: string | null) => {
  if (!value) return '';
  const str = String(value).trim();
  if (!str) return '';
  if (str.includes('-')) return str;
  const digits = str.replace(/[^0-9]/g, '');
  if (digits.length === 8) {
    return `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6, 8)}`;
  }
  return str;
};

// 270분초과 수가 여부 확인
const is270MinutesOverSuga = (patient: any): boolean => {
  return patient.sugaMinutesKey != null || (patient.sugaName && patient.sugaName.includes('270분초과'));
};

// 환자별 수가시간 가져오기 (270분초과 수가는 30분 휴게시간 적용)
// 단, 8시간 이상 시에는 휴게시간 차감 없음
const getPatientSugaHoursForCalc = (patient: any): number => {
  const baseHours = patient.sugaHours || 0;
  
  if (is270MinutesOverSuga(patient)) {
    if (baseHours >= 8) {
      return baseHours;
    }
    return Math.max(0, baseHours - 0.5);
  }
  
  return baseHours;
};

// 수가 키 생성 (StepThree와 동일)
const getSugaKeyForCalc = (patient: any): string => {
  if (patient.sugaMinutesKey != null) {
    return `${patient.sugaCode}_${patient.sugaMinutesKey}`;
  }
  return patient.sugaCode;
};

// 요양보호사 급여 계산 함수 (StepThree 로직 동일)
const calculatePayrollForYobo = (group: any, groupIndex: number) => {
  const settings = settingsData.value[groupIndex];
  if (!settings) return null;

  // 총 수가시간, 서비스 횟수 계산 (270분초과 휴게시간 적용)
  let totalSugaHours = 0;
  let serviceDays = 0;
  group.patients?.forEach((patient: any) => {
    const sugaKey = getSugaKeyForCalc(patient);
    let patientSugaHours: number;
    
    // 수동 조정된 수가시간이 있으면 사용, 없으면 휴게시간 적용된 시간 사용
    if (settings.customSugaHours?.[patient.patientCode]?.[sugaKey] !== undefined) {
      patientSugaHours = settings.customSugaHours[patient.patientCode][sugaKey];
    } else {
      patientSugaHours = getPatientSugaHoursForCalc(patient);
    }
    
    totalSugaHours += (patient.serviceDays || 0) * patientSugaHours;
    serviceDays += patient.serviceDays || 0;
  });

  // 평균 시급 계산 (가중평균) - 270분초과 휴게시간 적용
  let totalWeightedPay = 0;
  let totalHours = 0;
  
  group.patients?.forEach((patient: any) => {
    const sugaKey = getSugaKeyForCalc(patient);
    const timePay = settings.timePays?.[patient.patientCode]?.[sugaKey];
    if (timePay) {
      const numericPay = parseFloat(String(timePay).replace(/[^\d]/g, '')) || 0;
      
      // 수동 조정된 수가시간이 있으면 사용, 없으면 휴게시간 적용된 시간 사용
      let patientSugaHours: number;
      if (settings.customSugaHours?.[patient.patientCode]?.[sugaKey] !== undefined) {
        patientSugaHours = settings.customSugaHours[patient.patientCode][sugaKey];
      } else {
        patientSugaHours = getPatientSugaHoursForCalc(patient);
      }
      const sugaHours = (patient.serviceDays || 0) * patientSugaHours;
      
      if (numericPay > 0 && sugaHours > 0) {
        totalWeightedPay += numericPay * sugaHours;
        totalHours += sugaHours;
      }
    }
  });

  const avgTimePay = totalHours > 0 ? Math.round(totalWeightedPay / totalHours) : 0;
  const isFamilyOnlyCaregiver = group.patients?.every((p: any) => (p.sugaName || '').includes('가족')) || false;
  const totalMonthlyPay = totalWeightedPay;
  const longServicePay = settings.longServicePay ? 
    parseFloat(String(settings.longServicePay).replace(/[^\d]/g, '')) || 0 : 0;
  const etcAllowance = settings.etcAllowance ? 
    parseFloat(String(settings.etcAllowance).replace(/[^\d]/g, '')) || 0 : 0;
  const bosuEduPay = settings.bosuEduPay ? 
    parseFloat(String(settings.bosuEduPay).replace(/[^\d]/g, '')) || 0 : 0;
  
  // 수당 계산 (60시간 이상일 때만)
  const canApplyAllowances = totalSugaHours >= 60;
  
  // 휴일수당: 공휴일가산 수가 서비스 시간 기반으로 계산
  // 수가명에 '공휴일가산', '공휴일 가산' 또는 '공휴일'과 '가산'이 포함된 서비스만 대상
  let holidayTotalHours = 0;
  group.patients?.forEach((patient: any) => {
    const sugaName = patient.sugaName || '';
    const nameLower = sugaName.toLowerCase().replace(/\s/g, '');
    const isHolidaySuga = nameLower.includes('공휴일가산') || 
      (nameLower.includes('공휴일') && nameLower.includes('가산')) ||
      nameLower.includes('일요일가산') ||
      (nameLower.includes('일요일') && nameLower.includes('가산'));
    if (isHolidaySuga) {
      holidayTotalHours += (patient.serviceDays || 0) * (patient.sugaHours || 0);
    }
  });
  
  // 휴일수당/연장수당은 최저시급 기준으로 계산 (StepThree와 동일)
  const minWageForAllowance = taxData.value?.tr_time_pay || 0;
  const holidayAllowance = settings.applyHoliday && canApplyAllowances && holidayTotalHours > 0 && minWageForAllowance > 0 ? 
    Math.round(minWageForAllowance * holidayTotalHours * 0.5) : 0;
  const overtimeAllowance = settings.applyOvertime && canApplyAllowances && minWageForAllowance > 0 ? 
    Math.min(Math.round(minWageForAllowance * 4 * 1.5), 200000) : 0;
  
  // 기본급 등 계산
  let basicPay = 0;
  let holidayPay = 0;
  let vacationPay = 0;
  let actualMealAllowance = 0;
  
  if (isFamilyOnlyCaregiver) {
    basicPay = totalMonthlyPay;
  } else {
    const minWage = taxData.value?.tr_time_pay || 0;
    if (minWage > 0) {
      basicPay = minWage * totalSugaHours;
      holidayPay = Math.round(basicPay * 0.2);
      vacationPay = serviceDays > 0 ? Math.round((minWage * totalSugaHours / serviceDays) * 11 / 12) : 0;
      
      // 식대 계산
      if (settings.applyMeal && group.totalLunchTimeCount > 0) {
        const requestedMealAllowance = Math.min(group.totalLunchTimeCount * 20000, 200000);
        const currentBasicTotal = basicPay + holidayPay + vacationPay;
        const remainingAmount = Math.max(0, totalMonthlyPay - currentBasicTotal);
        const availableAmount = Math.min(requestedMealAllowance, remainingAmount);
        const roundedAmount = Math.floor(availableAmount / 100) * 100;
        if (roundedAmount >= 5000) {
          actualMealAllowance = roundedAmount;
        }
      }
      
      const currentTotal = basicPay + holidayPay + vacationPay + actualMealAllowance;
      if (currentTotal < totalMonthlyPay) {
        vacationPay += (totalMonthlyPay - currentTotal);
      }
    } else {
      basicPay = totalMonthlyPay;
    }
  }
  
  const basicTotal = isFamilyOnlyCaregiver ? totalMonthlyPay : (basicPay + holidayPay + vacationPay + actualMealAllowance);
  const totalPay = basicTotal + longServicePay + etcAllowance + bosuEduPay + holidayAllowance + overtimeAllowance;
  
  // 비과세 처리
  const isSalaryUnder2_1M = basicTotal <= 2100000;
  
  // 휴일수당 + 연장수당 비과세 처리 (합계 20만원 한도)
  let nonTaxableHoliday = 0;
  let nonTaxableOvertime = 0;
  
  if (canApplyAllowances && isSalaryUnder2_1M) {
    const totalOvertimeHolidayAllowance = holidayAllowance + overtimeAllowance;
    
    if (totalOvertimeHolidayAllowance <= 200000) {
      nonTaxableHoliday = holidayAllowance;
      nonTaxableOvertime = overtimeAllowance;
    } else {
      const nonTaxableRatio = 200000 / totalOvertimeHolidayAllowance;
      nonTaxableHoliday = Math.round(holidayAllowance * nonTaxableRatio);
      nonTaxableOvertime = Math.round(overtimeAllowance * nonTaxableRatio);
      const totalNonTaxable = nonTaxableHoliday + nonTaxableOvertime;
      if (totalNonTaxable !== 200000) {
        nonTaxableOvertime += (200000 - totalNonTaxable);
      }
    }
  }
  
  // 식대 비과세 한도 (20만원)
  const nonTaxableMeal = Math.min(actualMealAllowance, 200000);
  const taxableMeal = actualMealAllowance - nonTaxableMeal;
  
  const taxableHoliday = holidayAllowance - nonTaxableHoliday;
  const taxableOvertime = overtimeAllowance - nonTaxableOvertime;
  const taxableAmount = basicTotal + longServicePay + etcAllowance + bosuEduPay + taxableHoliday + taxableOvertime + taxableMeal - actualMealAllowance;
  const nonTaxableAmount = nonTaxableMeal + nonTaxableHoliday + nonTaxableOvertime;

  // 보험 요율
  // 보험 요율 (taxData에서 동적으로 가져옴)
  const insuranceRates = {
    nationalPension: taxData.value?.tr_yeon || 0.045,
    healthInsurance: taxData.value?.tr_gun || 0.03545,
    longTermCare: taxData.value?.tr_jang || 0.1295,
    employmentInsurance: taxData.value?.tr_go || 0.009,
    unemployment: taxData.value?.tr_sil || 0.009,
    industrialAccident: props.sanRate || taxData.value?.tr_san || 0.0178
  };

  const age = calculateAge(group.caregiverInfo?.caregiver_birth || '', yearMonth.value);
  
  // 국민연금 금액 사용 (체크박스 활성화 + 입력값이 있으면 사용, 체크 해제 시 0) - StepThree와 동일
  const yeonPayAmount = settings.applyNationalPension && settings.yeonPay ? 
    parseFloat(String(settings.yeonPay).replace(/[^\d]/g, '')) || 0 : 0;
  const canApplyPension = settings.applyNationalPension && yeonPayAmount > 0;
  // 고용보험 적용 여부 (체크박스 상태가 제한사항보다 우선) - StepThree와 동일
  const canApplyEmployment = settings.applyEmploymentInsurance;
  // 실업급여 적용 여부 (65세 이상은 고용보험과 별도 관리) - StepThree와 동일
  const canApplyUnemployment = settings.applyUnemployment;

  // 근로자 공제 (원단위 절삭 적용)
  const employeeDeductions = {
    nationalPension: canApplyPension ? truncateToTen(yeonPayAmount) : 0, // 직접 입력한 금액도 원단위 절삭
    healthInsurance: settings.applyHealthInsurance ? truncateToTen(taxableAmount * insuranceRates.healthInsurance) : 0,
    longTermCare: 0,
    employmentInsurance: canApplyEmployment ? truncateToTen(taxableAmount * insuranceRates.employmentInsurance) : 0,
    incomeTax: truncateToTen(taxableAmount * 0.03),
    localTax: 0
  };
  
  employeeDeductions.longTermCare = truncateToTen(employeeDeductions.healthInsurance * insuranceRates.longTermCare);
  employeeDeductions.localTax = truncateToTen(employeeDeductions.incomeTax * 0.1);

  // 본인부담금공제 금액 가져오기 (10원 단위 절사)
  const boninPayAmount = settings.applyBoninPay && settings.boninPay ? 
    truncateToTen(parseFloat(String(settings.boninPay).replace(/[^\d]/g, '')) || 0) : 0;

  // 기타공제 금액 가져오기
  const empEtcAmount = settings.applyEmpEtc && settings.empEtc ? 
    parseFloat(String(settings.empEtc).replace(/[^\d]/g, '')) || 0 : 0;

  // 지원공제 계산 (장기근속수당+중증수급자가산을 기관공제 방식으로 계산) - StepThree와 동일
  // 기관공제 항목: 국민연금 + 건강보험 + 장기요양 + 고용보험 + 실업급여 + 산재보험 + 퇴직금
  const severeCareAddition = 0; // 중증수급자가산 (현재 미사용)
  const supportDeductionBase = longServicePay + severeCareAddition;
  let supportDeduction = 0;
  if (supportDeductionBase > 0) {
    // 국민연금 (기관공제 = 근로자 부담과 동일)
    if (canApplyPension) {
      supportDeduction += truncateToTen(supportDeductionBase * insuranceRates.nationalPension);
    }
    // 건강보험 (기관공제 = 근로자 부담과 동일)
    let healthInsuranceSupport = 0;
    if (settings.applyHealthInsurance) {
      healthInsuranceSupport = truncateToTen(supportDeductionBase * insuranceRates.healthInsurance);
      supportDeduction += healthInsuranceSupport;
    }
    // 장기요양보험 (기관공제 = 근로자 부담과 동일) - 건강보험의 장기요양율
    if (settings.applyHealthInsurance) {
      supportDeduction += truncateToTen(healthInsuranceSupport * insuranceRates.longTermCare);
    }
    // 고용보험 (기관공제 = 근로자 부담과 동일) - StepThree와 동일
    if (canApplyEmployment) {
      supportDeduction += truncateToTen(supportDeductionBase * insuranceRates.employmentInsurance);
    }
    // 실업급여 (사업주 부담) - 실업급여 체크박스 (65세 이상은 별도 선택 가능) - StepThree와 동일
    if (canApplyUnemployment) {
      supportDeduction += truncateToTen(supportDeductionBase * insuranceRates.unemployment);
    }
    // 산재보험 (기관공제 - 사업주만 부담) - 항상 적용
    supportDeduction += truncateToTen(supportDeductionBase * insuranceRates.industrialAccident);
    // 퇴직금 (기관공제) - 지원공제 기준금액 ÷ 12 - StepThree와 동일
    if (settings.applyRetirement) {
      supportDeduction += truncateToTen(supportDeductionBase / 12);
    }
  }

  const totalEmployeeDeduction = 
    employeeDeductions.nationalPension + employeeDeductions.healthInsurance +
    employeeDeductions.longTermCare + employeeDeductions.employmentInsurance +
    employeeDeductions.incomeTax + employeeDeductions.localTax +
    supportDeduction + boninPayAmount + empEtcAmount;

  // 기관 공제 (체크박스 상태가 제한사항보다 우선, 원단위 절삭 적용) - StepThree와 동일
  const centerDeductions = {
    nationalPension: employeeDeductions.nationalPension,
    healthInsurance: employeeDeductions.healthInsurance,
    longTermCare: employeeDeductions.longTermCare,
    employmentInsurance: employeeDeductions.employmentInsurance,
    unemployment: canApplyUnemployment ? truncateToTen(taxableAmount * insuranceRates.unemployment) : 0,
    industrialAccident: truncateToTen(taxableAmount * insuranceRates.industrialAccident),
    retirement: settings.applyRetirement ? truncateToTen(totalPay / 12) : 0
  };

  const totalCenterDeduction =
    centerDeductions.nationalPension + centerDeductions.healthInsurance +
    centerDeductions.longTermCare + centerDeductions.employmentInsurance +
    centerDeductions.unemployment + centerDeductions.industrialAccident +
    centerDeductions.retirement;

  const netPay = totalPay - totalEmployeeDeduction;

  // 비과세 절감액 (TabYoboWage.vue 로직과 동일하게 적용)
  let centerTaxSavings = 0;
  if (nonTaxableAmount > 0 && taxData.value) {
    // 1. 국민연금 절감 (사업주 부담분) - 60세 미만 & 적용 시에만
    const centerPensionSavings = canApplyPension ? Math.round(nonTaxableAmount * (taxData.value.tr_yeon || 0.045)) : 0;
    
    // 2. 건강보험 + 장기요양보험 절감 (사업주 부담분) - 항상 적용
    const centerHealthSavings = Math.round(nonTaxableAmount * (taxData.value.tr_gun || 0.03545));
    const centerLongTermCareSavings = Math.round(centerHealthSavings * (taxData.value.tr_jang || 0.1295));
    
    // 3. 고용보험 절감 (사업주 부담분) - 65세 미만 & 적용 시에만
    const centerEmploymentSavings = canApplyEmployment ? Math.round(nonTaxableAmount * (taxData.value.tr_go || 0.009)) : 0;
    
    // 4. 실업급여 절감 (사업주 부담분) - 나이와 상관없이 항상 적용
    const unemploymentSavings = Math.round(nonTaxableAmount * (taxData.value.tr_sil || 0.009));
    
    // 5. 산재보험 절감 (사업주 부담분) - 나이와 상관없이 항상 적용 (기관별 산재보험요율 우선)
    const industrialAccidentSavings = Math.round(nonTaxableAmount * (props.sanRate || taxData.value.tr_san || 0.0178));
    
    centerTaxSavings = Math.max(0, centerPensionSavings + centerHealthSavings + centerLongTermCareSavings + centerEmploymentSavings + unemploymentSavings + industrialAccidentSavings);
  }

  return {
    avgTimePay,
    basicPay, holidayPay, vacationPay,
    mealAllowance: actualMealAllowance,
    basicTotal, longServicePay, etcAllowance, bosuEduPay,
    severeCareAddition: 0,
    holidayAllowance, overtimeAllowance, totalPay,
    taxableAmount, nonTaxableAmount,
    employeeDeductions, centerDeductions,
    supportDeduction,      // 지원공제
    boninPayAmount,        // 본인부담금공제
    empEtcAmount,          // 기타공제
    totalEmployeeDeduction, totalCenterDeduction,
    netPay, centerTaxSavings, employeeTaxSavings: 0,
    suga_hours: totalSugaHours,
    service_days: serviceDays
  };
};

// 요양보호사 데이터 가져오기
const fetchYoboData = async () => {
  const user = store.state.user;
  if (!user || !user.m_sisul_code || !yearMonth.value) return;

  try {
    // 세금 데이터 가져오기
    const year = yearMonth.value.substring(0, 4);
    const taxResponse = await axios.get(`/api/calc/tax/${year}`);
    if (taxResponse.data.success) {
      taxData.value = taxResponse.data.data.taxRate;
    }

    // 요양보호사 데이터 가져오기
    const memberJoinResponse = await axios.get('/api/calc/caregiver-member-join', {
      params: {
        sisulCode: user.m_sisul_code,
        lebYm: yearMonth.value
      },
      withCredentials: true
    });

    const rawMemberJoinData = memberJoinResponse.data.data || [];

    // 데이터 그룹화
    const grouped = new Map();
    
    rawMemberJoinData.forEach((item: any) => {
      const key = `${item.caregiver_name}_${item.caregiver_birth}`;
      if (!grouped.has(key)) {
        grouped.set(key, {
          name: item.caregiver_name,
          birth: item.caregiver_birth,
          caregiverInfo: {
            caregiver_name: item.caregiver_name,
            caregiver_birth: item.caregiver_birth,
            lem_gender: item.lem_gender,
            lem_license: item.lem_license,
            lem_work_start_date: item.lem_work_start_date,
            lem_work_end_date: item.lem_work_end_date
          },
          patients: [],
          originalItems: [],
          totalSugaMoney: 0,
          totalLunchTimeCount: 0
        });
      }
      
      const group = grouped.get(key);
      const sugaMoney = parseFloat(String(item.total_suga_money || 0).replace(/[^\d]/g, '')) || 0;
      group.totalSugaMoney += sugaMoney;
      const lunchCount = Number(item.lunch_time_count) || 0;
      group.totalLunchTimeCount += lunchCount;
      
      group.patients.push({
        patientCode: item.leb_patient_code,
        patientName: item.leb_patient_name || item.leb_patient_code,
        sugaCode: item.suga_code,
        sugaName: item.suga_name || '-',
        timePay: item.time_pay || '',
        serviceDays: item.service_days || 0,
        sugaHours: parseFloat(String(item.suga_hours || 0).replace(/[^\d.-]/g, '')) || 0,
        totalSugaMoney: sugaMoney,
        lunchTimeCount: lunchCount
      });
      
      group.originalItems.push(item);
    });

    // 그룹화된 데이터를 배열로 변환
    groupedMemberData.value = Array.from(grouped.values()).map((group, index) => {
      // 설정 데이터 초기화
      if (!settingsData.value[index]) {
        const firstItem = group.originalItems[0];
        const timePays: Record<string, Record<string, string>> = {};
        group.patients.forEach((patient: any) => {
          if (!timePays[patient.patientCode]) {
            timePays[patient.patientCode] = {};
          }
          let timePay = patient.timePay || '';
          if (timePay) {
            const numericValue = parseFloat(String(timePay).replace(/[^\d]/g, '')) || 0;
            if (numericValue > 0) {
              timePay = new Intl.NumberFormat('ko-KR').format(numericValue);
            }
          }
          timePays[patient.patientCode][patient.sugaCode] = timePay;
        });

        // 국민연금 금액 포맷팅
        let yeonPay = firstItem?.lemi_yeon_pay || '';
        let applyNationalPension = false;
        if (yeonPay) {
          const numericValue = parseFloat(String(yeonPay).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            yeonPay = new Intl.NumberFormat('ko-KR').format(numericValue);
            applyNationalPension = true;
          }
        }

        // 장기근속수당 포맷팅
        let longServicePay = firstItem?.lemi_long_service_pay || '';
        let applyLongServicePay = false;
        if (longServicePay) {
          const numericValue = parseFloat(String(longServicePay).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            longServicePay = new Intl.NumberFormat('ko-KR').format(numericValue);
            applyLongServicePay = true;
          }
        }

        // 보수교육비 포맷팅
        let bosuEduPay = firstItem?.lemi_bosu_edu_pay || '';
        let applyBosuEduPay = false;
        if (bosuEduPay) {
          const numericValue = parseFloat(String(bosuEduPay).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            bosuEduPay = new Intl.NumberFormat('ko-KR').format(numericValue);
            applyBosuEduPay = true;
          }
        }

        // 본인부담금공제 포맷팅
        let boninPay = firstItem?.lemi_bonin_pay || '';
        let applyBoninPay = false;
        if (boninPay) {
          const numericValue = parseFloat(String(boninPay).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            boninPay = new Intl.NumberFormat('ko-KR').format(numericValue);
            applyBoninPay = true;
          }
        }

        // 기타공제 포맷팅
        let empEtc = firstItem?.lemi_emp_etc || '';
        let applyEmpEtc = false;
        if (empEtc) {
          const numericValue = parseFloat(String(empEtc).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            empEtc = new Intl.NumberFormat('ko-KR').format(numericValue);
            applyEmpEtc = true;
          }
        }

        // 기타수당 포맷팅
        let etcAllowance = firstItem?.lemi_etc_allowance || '';
        let applyEtcAllowance = false;
        if (etcAllowance) {
          const numericValue = parseFloat(String(etcAllowance).replace(/[^\d]/g, '')) || 0;
          if (numericValue > 0) {
            etcAllowance = new Intl.NumberFormat('ko-KR').format(numericValue);
            applyEtcAllowance = true;
          }
        }

        settingsData.value[index] = {
          applyNationalPension: applyNationalPension,
          yeonPay: yeonPay,
          applyHealthInsurance: firstItem?.lemi_apply_gun === 'Y',
          applyEmploymentInsurance: firstItem?.lemi_apply_go === 'Y',
          applyRetirement: firstItem?.lemi_apply_out_pay === 'Y',
          applyHoliday: firstItem?.lemi_apply_holiday_pay === 'Y',
          applyOvertime: firstItem?.lemi_apply_overtime_pay === 'Y',
          applyMeal: firstItem?.lemi_apply_lunch_pay === 'Y',
          applyLongServicePay: applyLongServicePay,
          longServicePay: longServicePay,
          applyEtcAllowance: applyEtcAllowance,
          etcAllowance: etcAllowance,
          applyBosuEduPay: applyBosuEduPay,
          bosuEduPay: bosuEduPay,
          applyBoninPay: applyBoninPay,
          boninPay: boninPay,
          applyEmpEtc: applyEmpEtc,
          empEtc: empEtc,
          timePays: timePays
        };
      }
      
      // 급여 상세 계산
      const payroll = calculatePayrollForYobo(group, index);
      
      // 가족요양 전용 여부 확인
      const isFamilyOnlyCaregiver = group.patients?.every((p: any) => 
        (p.sugaName || '').includes('가족')
      ) || false;
      
      // payrollDetails 저장 (WageSlipPdf에서 사용)
      payrollDetails.value[index] = {
        avgTimePay: payroll?.avgTimePay || 0,
        basicPay: payroll?.basicPay || 0,
        holidayPay: payroll?.holidayPay || 0,
        vacationPay: payroll?.vacationPay || 0,
        mealAllowance: payroll?.mealAllowance || 0,
        longServicePay: payroll?.longServicePay || 0,
        etcAllowance: payroll?.etcAllowance || 0,
        bosuEduPay: payroll?.bosuEduPay || 0,
        severeCareAddition: payroll?.severeCareAddition || 0,
        holidayAllowance: payroll?.holidayAllowance || 0,
        overtimeAllowance: payroll?.overtimeAllowance || 0,
        totalPay: payroll?.totalPay || 0,
        employeeDeductions: payroll?.employeeDeductions || {},
        totalEmployeeDeduction: payroll?.totalEmployeeDeduction || 0,
        netPay: payroll?.netPay || 0,
        taxableAmount: payroll?.taxableAmount || 0,
        nonTaxableAmount: payroll?.nonTaxableAmount || 0,
        isFamilyOnlyCaregiver
      };
      
      // workTimeInfo 저장 (WageSlipPdf에서 사용)
      workTimeInfo.value[index] = {
        totalSugaHours: payroll?.suga_hours || 0,
        holidayMinutes: 0,    // 휴일근로 분 (나중에 실제 데이터로 대체)
        overtimeMinutes: 0,   // 연장근로 분 (나중에 실제 데이터로 대체)
        nightHours: 0
      };
      
      // WageReportExcel이 기대하는 구조로 변환
      return {
        ...group,
        _originalIndex: index,
        workStartDate: group.caregiverInfo?.lem_work_start_date || '',
        totals: {
          suga_hours: payroll?.suga_hours || 0,
          service_days: payroll?.service_days || 0,
          total_suga_money: group.totalSugaMoney,
          totalPay: payroll?.totalPay || 0,
          netPay: payroll?.netPay || 0,
          taxableAmount: payroll?.taxableAmount || 0,
          nonTaxableAmount: payroll?.nonTaxableAmount || 0,
          employeeTaxSavings: payroll?.employeeTaxSavings || 0,
          centerTaxSavings: payroll?.centerTaxSavings || 0,
          boninPayAmount: payroll?.boninPayAmount || 0,  // 본인부담금공제
          empEtcAmount: payroll?.empEtcAmount || 0       // 기타공제
        },
        allowances: {
          overtime: payroll?.overtimeAllowance || 0,
          holiday: payroll?.holidayAllowance || 0,
          laborDay: 0,
          longService: payroll?.longServicePay || 0,
          etcAllowance: payroll?.etcAllowance || 0,
          bosuEduPay: payroll?.bosuEduPay || 0,
          severeCareAddition: 0,
          meal: payroll?.mealAllowance || 0,
          other: 0
        },
        insurance: {
          nationalPension: { amount: payroll?.employeeDeductions?.nationalPension || 0 },
          healthInsurance: { amount: payroll?.employeeDeductions?.healthInsurance || 0 },
          longTermCare: { amount: payroll?.employeeDeductions?.longTermCare || 0 },
          employmentInsurance: { amount: payroll?.employeeDeductions?.employmentInsurance || 0 },
          unemployment: { amount: payroll?.centerDeductions?.unemployment || 0 },
          industrialAccident: { amount: payroll?.centerDeductions?.industrialAccident || 0 },
          supportDeduction: payroll?.supportDeduction || 0,
          boninPayDeduction: payroll?.boninPayAmount || 0,  // 본인부담금공제
          empEtcDeduction: payroll?.empEtcAmount || 0       // 기타공제
        },
        tax: {
          incomeTax: payroll?.employeeDeductions?.incomeTax || 0,
          localTax: payroll?.employeeDeductions?.localTax || 0
        }
      };
    });

  } catch (error) {
    console.error('요양보호사 데이터 조회 오류:', error);
    store.commit('showSnackbar', {
      text: '데이터를 불러오는 중 오류가 발생했습니다.',
      color: 'error'
    });
  }
};

// 사회복지사/센터장 급여 계산 함수 (StepFour의 TabSabokWage 로직 적용)
const calculatePayrollForSabok = (staff: any, settings: any) => {
  if (!settings) return null;

  const timePay = typeof settings.timePay === 'number' ? settings.timePay : parseInt(String(settings.timePay).replace(/,/g, '')) || 0;
  const workHours = typeof settings.workHours === 'number' ? settings.workHours : parseFloat(String(settings.workHours)) || 0;
  const totalPay = Math.floor(timePay * workHours);
  
  // 수당 계산
  const overtimeAllowance = typeof settings.overtimeAllowance === 'number' ? settings.overtimeAllowance : parseInt(String(settings.overtimeAllowance).replace(/,/g, '')) || 0;
  const nightAllowance = typeof settings.nightAllowance === 'number' ? settings.nightAllowance : parseInt(String(settings.nightAllowance).replace(/,/g, '')) || 0;
  const holidayAllowance = typeof settings.holidayAllowance === 'number' ? settings.holidayAllowance : parseInt(String(settings.holidayAllowance).replace(/,/g, '')) || 0;
  const annualLeaveAllowance = typeof settings.annualLeaveAllowance === 'number' ? settings.annualLeaveAllowance : parseInt(String(settings.annualLeaveAllowance).replace(/,/g, '')) || 0;
  const longServiceAllowance = typeof settings.longServiceAllowance === 'number' ? settings.longServiceAllowance : parseInt(String(settings.longServiceAllowance).replace(/,/g, '')) || 0;
  const mealAllowance = typeof settings.mealAllowance === 'number' ? settings.mealAllowance : parseInt(String(settings.mealAllowance).replace(/,/g, '')) || 0;
  const transportationFee = typeof settings.transportationFee === 'number' ? settings.transportationFee : parseInt(String(settings.transportationFee).replace(/,/g, '')) || 0;
  const educationFee = typeof settings.educationFee === 'number' ? settings.educationFee : parseInt(String(settings.educationFee).replace(/,/g, '')) || 0;
  const bonus = typeof settings.bonus === 'number' ? settings.bonus : parseInt(String(settings.bonus).replace(/,/g, '')) || 0;
  const vehicleAllowance = typeof settings.vehicleAllowance === 'number' ? settings.vehicleAllowance : parseInt(String(settings.vehicleAllowance).replace(/,/g, '')) || 0;
  const childEducationFee = typeof settings.childEducationFee === 'number' ? settings.childEducationFee : parseInt(String(settings.childEducationFee).replace(/,/g, '')) || 0;
  const otherAllowance = typeof settings.otherAllowance === 'number' ? settings.otherAllowance : parseInt(String(settings.otherAllowance).replace(/,/g, '')) || 0;

  const totalAllowances = overtimeAllowance + nightAllowance + holidayAllowance + annualLeaveAllowance + 
                          longServiceAllowance + mealAllowance + transportationFee + educationFee + 
                          bonus + vehicleAllowance + childEducationFee + otherAllowance;
  
  const finalTotalPay = totalPay + totalAllowances;

  // 과세/비과세 구분 (식대, 교통비, 교육비, 차량보조비, 자녀교육비는 비과세)
  const nonTaxableAmount = mealAllowance + transportationFee + educationFee + vehicleAllowance + childEducationFee;
  const taxableAmount = finalTotalPay - nonTaxableAmount;

  // 보험 요율 (taxData에서 동적으로 가져옴)
  const insuranceRates = {
    nationalPension: taxData.value?.tr_yeon || 0.045,
    healthInsurance: taxData.value?.tr_gun || 0.03545,
    longTermCare: taxData.value?.tr_jang || 0.1295,
    employmentInsurance: taxData.value?.tr_go || 0.009,
    unemployment: taxData.value?.tr_sil || 0.009,
    industrialAccident: props.sanRate || taxData.value?.tr_san || 0.0178
  };

  const age = calculateAge(settings.birthDate || staff.birth || '', yearMonth.value);
  const canApplyPension = age < 60;
  const canApplyEmployment = age < 65;

  // 근로자 공제 (원단위 절삭 적용)
  const employeeDeductions = {
    nationalPension: canApplyPension ? truncateToTen(taxableAmount * insuranceRates.nationalPension) : 0,
    healthInsurance: truncateToTen(taxableAmount * insuranceRates.healthInsurance),
    longTermCare: 0,
    employmentInsurance: canApplyEmployment ? truncateToTen(taxableAmount * insuranceRates.employmentInsurance) : 0,
    incomeTax: truncateToTen(taxableAmount * 0.03),
    localTax: 0
  };
  
  employeeDeductions.longTermCare = truncateToTen(employeeDeductions.healthInsurance * insuranceRates.longTermCare);
  employeeDeductions.localTax = truncateToTen(employeeDeductions.incomeTax * 0.1);

  const totalEmployeeDeduction = 
    employeeDeductions.nationalPension + employeeDeductions.healthInsurance +
    employeeDeductions.longTermCare + employeeDeductions.employmentInsurance +
    employeeDeductions.incomeTax + employeeDeductions.localTax;

  // 기관 공제 (원단위 절삭 적용)
  const centerDeductions = {
    nationalPension: employeeDeductions.nationalPension,
    healthInsurance: employeeDeductions.healthInsurance,
    longTermCare: employeeDeductions.longTermCare,
    employmentInsurance: employeeDeductions.employmentInsurance,
    unemployment: canApplyEmployment ? truncateToTen(taxableAmount * insuranceRates.unemployment) : 0,
    industrialAccident: truncateToTen(taxableAmount * insuranceRates.industrialAccident),
    retirement: truncateToTen(finalTotalPay / 12)
  };

  const totalCenterDeduction =
    centerDeductions.nationalPension + centerDeductions.healthInsurance +
    centerDeductions.longTermCare + centerDeductions.employmentInsurance +
    centerDeductions.unemployment + centerDeductions.industrialAccident +
    centerDeductions.retirement;

  const netPay = finalTotalPay - totalEmployeeDeduction;

  return {
    timePay, workHours, totalPay: finalTotalPay,
    overtimeAllowance, nightAllowance, holidayAllowance,
    annualLeaveAllowance, longServiceAllowance,
    mealAllowance, transportationFee, educationFee,
    bonus, vehicleAllowance, childEducationFee, otherAllowance,
    taxableAmount, nonTaxableAmount,
    employeeDeductions, centerDeductions,
    totalEmployeeDeduction, totalCenterDeduction,
    netPay, centerTaxSavings: 0, employeeTaxSavings: 0,
    age
  };
};

// 사회복지사/센터장 데이터 가져오기
const fetchSabokData = async () => {
  const user = store.state.user;
  if (!user || !user.m_sisul_code || !yearMonth.value) return;

  try {
    const response = await axios.get(`/api/calc/employee-sabok/${user.m_sisul_code}`);
    
    if (response.data.success) {
      const employees = response.data.data;
      const currentYm = yearMonth.value;
      
      // 입사일에 따라 필터링
      const filteredEmployees = employees.filter((emp: any) => {
        if (!emp.emp_in_date) return true;
        const empInDate = emp.emp_in_date.replace(/-/g, '');
        const empInYm = empInDate.substring(0, 6);
        return currentYm >= empInYm;
      });
      
      // 근무/급여 정보 조회
      const workInfoResponse = await axios.get(`/api/calc/work-info/${user.m_sisul_code}/${currentYm}`);
      const workInfoMap = new Map();
      
      if (workInfoResponse.data.success && workInfoResponse.data.data) {
        workInfoResponse.data.data.forEach((workInfo: any) => {
          workInfoMap.set(workInfo.emp_code, workInfo);
        });
      }
      
      // 데이터 변환
      sabokStaffData.value = filteredEmployees.map((emp: any) => {
        const workInfo = workInfoMap.get(emp.emp_code);
        let timePay = 0;
        if (workInfo?.ewi_basic_pay && workInfo?.ewi_suga_hours) {
          timePay = Math.round(workInfo.ewi_basic_pay / workInfo.ewi_suga_hours);
        }
        
        const formattedBirth = formatToYMD(emp.emp_birth);
        
        return {
          empCode: emp.emp_code,
          name: emp.emp_name || '',
          type: emp.emp_job || '',
          timePay: timePay,
          workHours: workInfo?.ewi_suga_hours || 0,
          salary: workInfo?.ewi_basic_pay || 0,
          allowance: (workInfo?.ewi_overtime_pay || 0) + (workInfo?.ewi_holiday_pay || 0) + 
                     (workInfo?.ewi_annual_pay || 0) + (workInfo?.ewi_long_service_pay || 0) +
                     (workInfo?.ewi_bosu_edu_pay || 0) + (workInfo?.ewi_meal_pay || 0) + (workInfo?.ewi_other_pay || 0),
          totalSalary: workInfo?.ewi_total_pay || 0,
          workStartDate: emp.emp_in_date || '',
          workEndDate: emp.emp_out_date || '',
          birth: formattedBirth,
          phone: emp.emp_phone || '',
          email: emp.emp_email || '',
          address: emp.emp_addr || '',
          addressDetail: emp.emp_addr_detail || '',
          isBoss: emp.emp_isboss === 'Y'
        };
      });

      // 설정 데이터 초기화 및 급여 계산
      sabokStaffData.value.forEach((staff, index) => {
        if (!sabokStaffSettings.value[index]) {
          const workInfo = workInfoMap.get(staff.empCode);
          const isBoss = staff.isBoss || false;
          
          sabokStaffSettings.value[index] = {
            name: staff.name,
            type: staff.type,
            birthDate: formatToYMD(staff.birth),
            workStartDate: staff.workStartDate,
            timePay: staff.timePay,
            workHours: staff.workHours,
            overtimeHours: 0,
            nightHours: 0,
            holidayHours: 0,
            overtimeAllowance: workInfo?.ewi_overtime_pay || 0,
            nightAllowance: 0,
            holidayAllowance: workInfo?.ewi_holiday_pay || 0,
            annualLeaveAllowance: workInfo?.ewi_annual_pay || 0,
            longServiceAllowance: workInfo?.ewi_long_service_pay || 0,
            bosuEduPayAllowance: workInfo?.ewi_bosu_edu_pay || 0,
            transportationFee: 0,
            educationFee: 0,
            bonus: 0,
            otherAllowance: workInfo?.ewi_other_pay || 0,
            mealAllowance: workInfo?.ewi_meal_pay || 0,
            vehicleAllowance: 0,
            childEducationFee: 0,
            isBoss: isBoss
          };
          
          // 급여 계산 결과 추가
          const payroll = calculatePayrollForSabok(staff, sabokStaffSettings.value[index]);
          if (payroll) {
            // DB에 저장된 공제 금액이 있으면 사용, 없으면 계산 값 사용
            // 대표자인 경우 고용보험, 실업급여, 산재보험, 퇴직금은 0원
            sabokStaffSettings.value[index].insurance = {
              nationalPension: { amount: workInfo?.ewi_emp_guk ?? payroll.employeeDeductions.nationalPension },
              healthInsurance: { amount: workInfo?.ewi_emp_gun ?? payroll.employeeDeductions.healthInsurance },
              longTermCare: { amount: workInfo?.ewi_emp_jang ?? payroll.employeeDeductions.longTermCare },
              employmentInsurance: { amount: isBoss ? 0 : (workInfo?.ewi_emp_goy ?? payroll.employeeDeductions.employmentInsurance) },
              unemployment: { amount: isBoss ? 0 : (workInfo?.ewi_center_sil ?? payroll.centerDeductions.unemployment) },
              industrialAccident: { amount: isBoss ? 0 : (workInfo?.ewi_center_san ?? payroll.centerDeductions.industrialAccident) },
              retirement: { amount: isBoss ? 0 : (workInfo?.ewi_center_out ?? payroll.centerDeductions.retirement) },
              supportDeduction: { amount: workInfo?.ewi_emp_support_deduction || 0 }
            };
            sabokStaffSettings.value[index].tax = {
              incomeTax: workInfo?.ewi_emp_income_tax ?? payroll.employeeDeductions.incomeTax,
              localTax: workInfo?.ewi_emp_local_tax ?? payroll.employeeDeductions.localTax
            };
            sabokStaffSettings.value[index].totals = {
              netPay: workInfo?.ewi_net_pay ?? payroll.netPay,
              nonTaxableAmount: payroll.nonTaxableAmount,
              employeeTaxSavings: payroll.employeeTaxSavings,
              centerTaxSavings: payroll.centerTaxSavings
            };
            sabokStaffSettings.value[index].age = payroll.age;
          }
        }
      });
    }
  } catch (error) {
    console.error('사회복지사/센터장 데이터 조회 오류:', error);
  }
};

// 엑셀 다운로드
const handleDownloadExcel = async () => {
  if (!wageReportExcelRef.value) return;

  if (!hasDownloadableData.value) {
    await loadDownloadData();
  }

  if (!hasDownloadableData.value) {
    store.commit('showSnackbar', {
      text: '다운로드할 데이터가 없습니다. 먼저 급여 데이터를 확인해주세요.',
      color: 'warning'
    });
    return;
  }
  
  try {
    if (isLoadingData.value) {
      await loadDownloadData();
    }
    await wageReportExcelRef.value.downloadPayrollReport();
  } catch (error) {
    console.error('엑셀 다운로드 오류:', error);
    store.commit('showSnackbar', {
      text: '엑셀 다운로드 중 오류가 발생했습니다.',
      color: 'error'
    });
  }
};

// Snackbar 핸들러
const handleSnackbar = (message: string, type: string) => {
  store.commit('showSnackbar', {
    text: message,
    color: type
  });
};

// 확정 버튼 클릭
const handleConfirm = () => {
  showConfirmDialog.value = true;
};

// 확정 진행
const proceedConfirm = () => {
  showConfirmDialog.value = false;
  emit('confirm');
};

// 해제 버튼 클릭
const handleRelease = () => {
  // 임금신고 요청을 하지 않았거나 취소한 경우에만 해제 가능
  if (!canReleaseConfirmation.value) {
    const status = taxRequestData.value?.wtr_status;
    let message = '임금신고 요청 중에는 확정을 해제할 수 없습니다.';
    
    if (status === '요청') {
      message = '임금신고 요청 중에는 확정을 해제할 수 없습니다. 먼저 요청을 취소해주세요.';
    } else if (status === '승인') {
      message = '임금신고가 승인된 상태에서는 확정을 해제할 수 없습니다.';
    } else if (status === '미승인') {
      message = '임금신고가 미승인된 상태입니다. 새로운 요청을 진행해주세요.';
    }
    
    store.commit('showSnackbar', {
      text: message,
      color: 'warning'
    });
    return;
  }
  showReleaseDialog.value = true;
};

// 해제 진행
const proceedRelease = () => {
  showReleaseDialog.value = false;
  emit('release');
};

let dataLoadPromise: Promise<void> | null = null;

const loadDownloadData = async () => {
  // 이미 로딩 중이면 해당 프로미스를 기다림
  if (isLoadingData.value && dataLoadPromise) {
    await dataLoadPromise;
    return;
  }
  
  if (!stepCompleted.value || !yearMonth.value) return;

  isLoadingData.value = true;
  dataLoadPromise = (async () => {
    try {
      // hh_emp_sabok_work_info 테이블에서 직접 데이터 가져오기
      const user = store.state.user;
      if (!user || !user.m_sisul_code) {
        workInfoData.value = [];
        return;
      }
      const response = await axios.get(`/api/calc/work-info/${user.m_sisul_code}/${yearMonth.value}`);
      if (response.data.success && response.data.data) {
        workInfoData.value = response.data.data;
      } else {
        workInfoData.value = [];
      }
      
      // PDF용 데이터는 기존 방식으로 유지
      await Promise.all([fetchYoboData(), fetchSabokData()]);
    } catch (error) {
      console.error('데이터 로드 중 오류:', error);
      store.commit('showSnackbar', {
        text: '데이터를 불러오는 중 오류가 발생했습니다.',
        color: 'error'
      });
    } finally {
      isLoadingData.value = false;
      dataLoadPromise = null;
    }
  })();
  await dataLoadPromise;
};

// stepCompleted 변경 시 데이터 로드 (immediate: true가 초기 로드 처리)
watch(() => props.stepCompleted, async (newVal) => {
  if (newVal) {
    await loadDownloadData();
  }
  // 임금신고 요청 상태 로드
  await loadTaxRequestStatus();
}, { immediate: true });

// yearMonth 변경 시 데이터 다시 로드
watch(() => props.yearMonth, async () => {
  if (stepCompleted.value) {
    await loadDownloadData();
  }
  // 임금신고 요청 상태 다시 로드
  await loadTaxRequestStatus();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "32",
          color: "#00C73C"
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("mdi-party-popper", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "panel-title-section" }, [
        _createElementVNode("h2", { class: "panel-title" }, "임금관리결과 확인하기"),
        _createElementVNode("p", { class: "panel-subtitle" }, "모든 준비가 완료되었습니다. 계산된 임금관리결과를 확인하고 출력하세요")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_v_icon, {
          color: "#00C73C",
          size: "48"
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode("mdi-check-circle", -1)
          ]))]),
          _: 1
        }),
        _cache[13] || (_cache[13] = _createElementVNode("h3", null, "축하합니다!", -1)),
        _cache[14] || (_cache[14] = _createElementVNode("p", null, "임금 관리를 위한 모든 단계를 완료했어요", -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["feature-item clickable", { 'disabled': isLoadingData.value }]),
          onClick: handleOpenWageSlip
        }, [
          _createVNode(_component_v_icon, { color: "#1e3a8a" }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createTextVNode("mdi-account-cash", -1)
            ]))]),
            _: 1
          }),
          _cache[16] || (_cache[16] = _createElementVNode("h4", null, "급여 명세서", -1)),
          _cache[17] || (_cache[17] = _createElementVNode("p", null, "개인별 급여 명세서 확인", -1))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["feature-item clickable", { 'disabled': isLoadingData.value }]),
          onClick: handleDownloadExcel
        }, [
          _createVNode(_component_v_icon, { color: "#1e3a8a" }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode("mdi-file-excel", -1)
            ]))]),
            _: 1
          }),
          _cache[19] || (_cache[19] = _createElementVNode("h4", null, "임금대장 엑셀 다운로드", -1)),
          _cache[20] || (_cache[20] = _createElementVNode("p", null, "급여 데이터 엑셀 저장", -1))
        ], 2),
        _createElementVNode("div", {
          class: "feature-item clickable",
          onClick: handleGoDashboard
        }, [
          _createVNode(_component_v_icon, { color: "#1e3a8a" }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
              _createTextVNode("mdi-chart-line", -1)
            ]))]),
            _: 1
          }),
          _cache[22] || (_cache[22] = _createElementVNode("h4", null, "기관 운영 현황 보기", -1)),
          _cache[23] || (_cache[23] = _createElementVNode("p", null, "운영 현황 이동", -1))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["feature-item clickable", { 'has-request': hasActiveRequest.value }]),
          onClick: handleOpenTaxReq
        }, [
          _createVNode(_component_v_icon, {
            color: hasActiveRequest.value ? '#10b981' : '#1e3a8a'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(hasActiveRequest.value ? 'mdi-check-decagram' : 'mdi-file-document-edit'), 1)
            ]),
            _: 1
          }, 8, ["color"]),
          _cache[24] || (_cache[24] = _createElementVNode("h4", null, "임금신고 요청", -1)),
          _createElementVNode("p", null, _toDisplayString(taxRequestStatusText.value), 1),
          (hasActiveRequest.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "요청중"))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["feature-item clickable", { 'disabled': isLoadingData.value }]),
          onClick: handleOpenJobSummary
        }, [
          _createVNode(_component_v_icon, { color: "#1e3a8a" }, {
            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
              _createTextVNode("mdi-chart-bar", -1)
            ]))]),
            _: 1
          }),
          _cache[26] || (_cache[26] = _createElementVNode("h4", null, "인건비 지출비율 참고", -1)),
          _cache[27] || (_cache[27] = _createElementVNode("p", null, "종사자구분별 인원·임금·보험·퇴직금", -1))
        ], 2)
      ]),
      (stepCompleted.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["status-card", isConfirmed.value ? 'info' : 'success'])
          }, [
            _createVNode(_component_v_icon, {
              color: isConfirmed.value ? '#10b981' : '#00C73C',
              size: "24"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(isConfirmed.value ? 'mdi-lock-check' : 'mdi-check-circle'), 1)
              ]),
              _: 1
            }, 8, ["color"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h4", null, _toDisplayString(isConfirmed.value ? '임금관리결과 확정됨' : '임금관리결과 확인 완료'), 1),
              _createElementVNode("p", null, _toDisplayString(isConfirmed.value
              ? '확정 상태예요. 해제 후에만 임금관리결과를 수정할 수 있습니다.'
              : '임금관리결과 확인이 완료되었습니다. 확정을 눌러 완료하세요.'), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (isConfirmed.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn-outline",
                    onClick: handleRelease,
                    disabled: isConfirming.value || !canReleaseConfirmation.value,
                    title: !canReleaseConfirmation.value ? '임금신고 요청 상태에서는 해제할 수 없습니다' : ''
                  }, [
                    (isConfirming.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          size: "16",
                          width: "2",
                          color: "#047857",
                          class: "mr-1"
                        }))
                      : _createCommentVNode("", true),
                    (!canReleaseConfirmation.value)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          size: "16",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                            _createTextVNode("mdi-lock", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _cache[29] || (_cache[29] = _createTextVNode(" 확정 해제 ", -1))
                  ], 8, _hoisted_10))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn-outline",
                    onClick: handleConfirm,
                    disabled: !stepCompleted.value || isConfirming.value
                  }, [
                    (isConfirming.value)
                      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                          key: 0,
                          indeterminate: "",
                          size: "16",
                          width: "2",
                          color: "#047857",
                          class: "mr-1"
                        }))
                      : _createCommentVNode("", true),
                    _cache[30] || (_cache[30] = _createTextVNode(" 임금관리결과 확정하기 ", -1))
                  ], 8, _hoisted_11))
            ])
          ], 2))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn-primary-large celebrate",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('view-result'))),
            disabled: isConfirmed.value
          }, [
            _createVNode(_component_v_icon, { class: "btn-icon" }, {
              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                _createTextVNode("mdi-rocket-launch", -1)
              ]))]),
              _: 1
            }),
            _cache[32] || (_cache[32] = _createElementVNode("span", null, "임금관리결과 보러 가기", -1))
          ], 8, _hoisted_12)),
      _createVNode(WageReportExcel, {
        ref_key: "wageReportExcelRef",
        ref: wageReportExcelRef,
        "leb-ym": yearMonth.value,
        "work-info-data": workInfoData.value,
        "sisul-code": _unref(store).state.user?.m_sisul_code || '',
        onShowSnackbar: handleSnackbar
      }, null, 8, ["leb-ym", "work-info-data", "sisul-code"]),
      _createVNode(WageSlipPdf, {
        ref_key: "wageSlipPdfRef",
        ref: wageSlipPdfRef,
        "grouped-member-data": groupedMemberData.value,
        "leb-ym": yearMonth.value,
        "tax-data": taxData.value,
        "settings-data": settingsData.value,
        "payroll-details": payrollDetails.value,
        "work-time-info": workTimeInfo.value,
        "sabok-staff-data": sabokStaffData.value,
        "sabok-staff-settings": sabokStaffSettings.value,
        "payment-date": props.paymentDate,
        onShowSnackbar: handleSnackbar
      }, null, 8, ["grouped-member-data", "leb-ym", "tax-data", "settings-data", "payroll-details", "work-time-info", "sabok-staff-data", "sabok-staff-settings", "payment-date"]),
      _createVNode(_component_v_dialog, {
        modelValue: showConfirmDialog.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showConfirmDialog).value = $event)),
        "max-width": "440px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "confirm-dialog" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_v_icon, {
                  size: "48",
                  color: "#10b981"
                }, {
                  default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                    _createTextVNode("mdi-lock-check", -1)
                  ]))]),
                  _: 1
                }),
                _cache[34] || (_cache[34] = _createElementVNode("h3", null, "임금관리결과 확정", -1))
              ]),
              _cache[35] || (_cache[35] = _createElementVNode("div", { class: "confirm-dialog-body" }, [
                _createElementVNode("p", null, "임금관리결과를 확정하시겠습니까?"),
                _createElementVNode("p", null, "확정 후에는 임금관리결과를 수정할 수 없습니다.")
              ], -1)),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  class: "btn-cancel",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showConfirmDialog.value = false))
                }, "취소"),
                _createElementVNode("button", {
                  class: "btn-confirm",
                  onClick: proceedConfirm
                }, "확정")
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: showReleaseDialog.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showReleaseDialog).value = $event)),
        "max-width": "440px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "confirm-dialog" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_v_icon, {
                  size: "48",
                  color: "#f59e0b"
                }, {
                  default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                    _createTextVNode("mdi-alert-circle", -1)
                  ]))]),
                  _: 1
                }),
                _cache[37] || (_cache[37] = _createElementVNode("h3", null, "확정 해제", -1))
              ]),
              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "confirm-dialog-body" }, [
                _createElementVNode("p", null, "임금관리결과 확정을 해제하시겠습니까?"),
                _createElementVNode("p", null, "해제 후에는 다시 수정이 가능합니다.")
              ], -1)),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("button", {
                  class: "btn-cancel",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showReleaseDialog.value = false))
                }, "취소"),
                _createElementVNode("button", {
                  class: "btn-confirm warning",
                  onClick: proceedRelease
                }, "해제")
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(WageTaxReq, {
        modelValue: showTaxReqDialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showTaxReqDialog).value = $event)),
        "year-month": yearMonth.value,
        onRequestSubmitted: handleTaxReqSubmitted,
        onRequestCancelled: handleTaxReqCancelled
      }, null, 8, ["modelValue", "year-month"]),
      _createVNode(_component_v_dialog, {
        modelValue: showJobSummaryDialog.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((showJobSummaryDialog).value = $event)),
        "max-width": "860px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, { class: "job-summary-dialog" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_v_icon, {
                    size: "28",
                    color: "#1e3a8a"
                  }, {
                    default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                      _createTextVNode("mdi-chart-bar", -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("div", null, [
                    _cache[40] || (_cache[40] = _createElementVNode("h3", null, "인건비 지출비율 참고", -1)),
                    _createElementVNode("p", _hoisted_19, _toDisplayString(formattedYearMonth.value) + " 기준", 1)
                  ])
                ]),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  size: "small",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (showJobSummaryDialog.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_20, [
                (jobSummaryData.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_v_icon, {
                        size: "48",
                        color: "#ccc"
                      }, {
                        default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                          _createTextVNode("mdi-database-off", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[43] || (_cache[43] = _createElementVNode("p", null, "데이터가 없습니다. 먼저 급여 데이터를 확인해주세요.", -1))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("table", _hoisted_23, [
                        _cache[45] || (_cache[45] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { class: "col-job" }, "종사자구분"),
                            _createElementVNode("th", { class: "col-num" }, "인원"),
                            _createElementVNode("th", { class: "col-money" }, "임금총액"),
                            _createElementVNode("th", { class: "col-money" }, [
                              _createTextVNode(" 사회보험"),
                              _createElementVNode("br"),
                              _createElementVNode("span", { class: "sub-label" }, "(기관부담)")
                            ]),
                            _createElementVNode("th", { class: "col-money" }, "퇴직적립금"),
                            _createElementVNode("th", { class: "col-money" }, [
                              _createTextVNode(" 기관부담 합계"),
                              _createElementVNode("br"),
                              _createElementVNode("span", { class: "sub-label" }, "(보험+퇴직)")
                            ])
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobSummaryData.value, (row, idx) => {
                            return (_openBlock(), _createElementBlock("tr", { key: idx }, [
                              _createElementVNode("td", _hoisted_24, [
                                _createElementVNode("span", {
                                  class: "job-badge",
                                  style: _normalizeStyle({ background: getJobColor(row.job) })
                                }, _toDisplayString(row.job), 5)
                              ]),
                              _createElementVNode("td", _hoisted_25, _toDisplayString(row.count) + "명", 1),
                              _createElementVNode("td", _hoisted_26, _toDisplayString(formatMoney(row.totalPay)), 1),
                              _createElementVNode("td", _hoisted_27, _toDisplayString(formatMoney(row.socialInsurance)), 1),
                              _createElementVNode("td", _hoisted_28, _toDisplayString(formatMoney(row.retirement)), 1),
                              _createElementVNode("td", _hoisted_29, _toDisplayString(formatMoney(row.socialInsurance + row.retirement)), 1)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("tfoot", null, [
                          _createElementVNode("tr", _hoisted_30, [
                            _cache[44] || (_cache[44] = _createElementVNode("td", { class: "col-job" }, [
                              _createElementVNode("strong", null, "합계")
                            ], -1)),
                            _createElementVNode("td", _hoisted_31, [
                              _createElementVNode("strong", null, _toDisplayString(jobSummaryTotals.value.count) + "명", 1)
                            ]),
                            _createElementVNode("td", _hoisted_32, [
                              _createElementVNode("strong", null, _toDisplayString(formatMoney(jobSummaryTotals.value.totalPay)), 1)
                            ]),
                            _createElementVNode("td", _hoisted_33, [
                              _createElementVNode("strong", null, _toDisplayString(formatMoney(jobSummaryTotals.value.socialInsurance)), 1)
                            ]),
                            _createElementVNode("td", _hoisted_34, [
                              _createElementVNode("strong", null, _toDisplayString(formatMoney(jobSummaryTotals.value.retirement)), 1)
                            ]),
                            _createElementVNode("td", _hoisted_35, [
                              _createElementVNode("strong", null, _toDisplayString(formatMoney(jobSummaryTotals.value.socialInsurance + jobSummaryTotals.value.retirement)), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("h4", {
                          class: "detail-title",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (showInsuranceDetail.value = !showInsuranceDetail.value)),
                          style: {"cursor":"pointer"}
                        }, [
                          _createVNode(_component_v_icon, { size: "18" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(showInsuranceDetail.value ? 'mdi-chevron-down' : 'mdi-chevron-right'), 1)
                            ]),
                            _: 1
                          }),
                          _cache[46] || (_cache[46] = _createTextVNode(" 사회보험 기관부담금 상세 ", -1))
                        ]),
                        (showInsuranceDetail.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _createElementVNode("table", _hoisted_38, [
                                _cache[48] || (_cache[48] = _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", { class: "col-job" }, "종사자구분"),
                                    _createElementVNode("th", { class: "col-money-sm" }, "국민연금"),
                                    _createElementVNode("th", { class: "col-money-sm" }, "건강보험"),
                                    _createElementVNode("th", { class: "col-money-sm" }, "장기요양"),
                                    _createElementVNode("th", { class: "col-money-sm" }, "고용보험"),
                                    _createElementVNode("th", { class: "col-money-sm" }, "실업급여"),
                                    _createElementVNode("th", { class: "col-money-sm" }, "산재보험"),
                                    _createElementVNode("th", { class: "col-money-sm" }, "합계")
                                  ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobSummaryData.value, (row, idx) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: 'd-'+idx
                                    }, [
                                      _createElementVNode("td", _hoisted_39, [
                                        _createElementVNode("span", {
                                          class: "job-badge",
                                          style: _normalizeStyle({ background: getJobColor(row.job) })
                                        }, _toDisplayString(row.job), 5)
                                      ]),
                                      _createElementVNode("td", _hoisted_40, _toDisplayString(formatMoney(row.detail.nationalPension)), 1),
                                      _createElementVNode("td", _hoisted_41, _toDisplayString(formatMoney(row.detail.healthInsurance)), 1),
                                      _createElementVNode("td", _hoisted_42, _toDisplayString(formatMoney(row.detail.longTermCare)), 1),
                                      _createElementVNode("td", _hoisted_43, _toDisplayString(formatMoney(row.detail.employmentInsurance)), 1),
                                      _createElementVNode("td", _hoisted_44, _toDisplayString(formatMoney(row.detail.unemployment)), 1),
                                      _createElementVNode("td", _hoisted_45, _toDisplayString(formatMoney(row.detail.industrialAccident)), 1),
                                      _createElementVNode("td", _hoisted_46, _toDisplayString(formatMoney(row.socialInsurance)), 1)
                                    ]))
                                  }), 128))
                                ]),
                                _createElementVNode("tfoot", null, [
                                  _createElementVNode("tr", _hoisted_47, [
                                    _cache[47] || (_cache[47] = _createElementVNode("td", { class: "col-job" }, [
                                      _createElementVNode("strong", null, "합계")
                                    ], -1)),
                                    _createElementVNode("td", _hoisted_48, [
                                      _createElementVNode("strong", null, _toDisplayString(formatMoney(jobSummaryTotals.value.detail.nationalPension)), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_49, [
                                      _createElementVNode("strong", null, _toDisplayString(formatMoney(jobSummaryTotals.value.detail.healthInsurance)), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_50, [
                                      _createElementVNode("strong", null, _toDisplayString(formatMoney(jobSummaryTotals.value.detail.longTermCare)), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_51, [
                                      _createElementVNode("strong", null, _toDisplayString(formatMoney(jobSummaryTotals.value.detail.employmentInsurance)), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_52, [
                                      _createElementVNode("strong", null, _toDisplayString(formatMoney(jobSummaryTotals.value.detail.unemployment)), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_53, [
                                      _createElementVNode("strong", null, _toDisplayString(formatMoney(jobSummaryTotals.value.detail.industrialAccident)), 1)
                                    ]),
                                    _createElementVNode("td", _hoisted_54, [
                                      _createElementVNode("strong", null, _toDisplayString(formatMoney(jobSummaryTotals.value.socialInsurance)), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (showJobSummaryDialog.value = false))
                }, {
                  default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                    _createTextVNode("닫기", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})